/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChestXrayResult {
    NORMAL = 'normal',
    SUGGESTIVE_OF_TB = 'suggestiveOfTb',
}
